import { translate } from '@jsverse/transloco';
export enum AssessmentAssessorInstanceRole {
    LEAD = 'LEAD',
    ASSESSOR = 'ASSESSOR',
    ASSOCIATE = 'ASSOCIATE',
    QA = 'QA',
    CUSTOMER = 'CUSTOMER',
}

export enum AssessmentCustomerInstanceRole {
    CUSTOMER_MANAGER = 'CUSTOMER_MANAGER',
    CUSTOMER_TEAM_LEAD = 'CUSTOMER_TEAM_LEAD',
    CUSTOMER = 'CUSTOMER',
}

export class AssessmentInstanceRoleHelper {
    static getAssessorRoleLocale(role: AssessmentAssessorInstanceRole): string {
        switch (role) {
            case AssessmentAssessorInstanceRole.LEAD:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.LEAD');
            case AssessmentAssessorInstanceRole.ASSESSOR:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.ASSESSOR');
            case AssessmentAssessorInstanceRole.ASSOCIATE:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.ASSOCIATE');
            case AssessmentAssessorInstanceRole.QA:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.QA');
            case AssessmentAssessorInstanceRole.CUSTOMER:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.CUSTOMER');
            default:
                return role;
        }
    }
    static getCustomerRoleLocale(role: AssessmentCustomerInstanceRole): string {
        switch (role) {
            case AssessmentCustomerInstanceRole.CUSTOMER_MANAGER:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.CUSTOMER_MANAGER');
            case AssessmentCustomerInstanceRole.CUSTOMER_TEAM_LEAD:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.CUSTOMER_LEAD');
            case AssessmentCustomerInstanceRole.CUSTOMER:
                return translate('CORE.ASSESSMENT_INSTANCE_ROLES.CUSTOMER_USER');
            default:
                return role;
        }
    }
}
